import type { Persona } from './types';

/**
 * Determines the current persona from the URL pathname.
 * - `/team*`  → manager
 * - `/my*`    → employee
 * - anything else (including `/dashboard`, `/hr/`, `/admin/`, `/billing/`, `/workflows/`,
 *   `/ged/`, `/payments/`, `/inbox`) → agency
 */
export function personaFromPath(pathname: string): Persona {
  if (pathname.startsWith('/team')) return 'manager';
  if (pathname.startsWith('/my')) return 'employee';
  return 'agency';
}
